import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { api } from '@/shared/api/cliente';
import { ErrorDeApi } from '@/shared/api/problema';
import { notificar } from '@/shared/ui/avisos';
import { FORMATOS } from './catalogo';

export function BotonesDeExportacion({
  rotulo,
  ruta,
  nombre,
  parametros = {},
}: {
  rotulo?: string;
  ruta: string;
  nombre: string;
  parametros?: Record<string, string>;
}) {
  const [ocupado, setOcupado] = useState<string | null>(null);

  async function sacar(formato: string) {
    setOcupado(formato);

    try {
      const consulta = new URLSearchParams({ ...parametros, formato });
      const fichero = await api.descargar(`${ruta}?${consulta}`);

      if (!fichero) {
        notificar.error('NO SE PUDO ARMAR EL INFORME');
        return;
      }

      const url = URL.createObjectURL(fichero);

      if (formato === 'pdf') {
        const abierta = window.open(url, '_blank');
        if (!abierta) {
          bajar(url, `${nombre}.pdf`);
        }

        setTimeout(() => URL.revokeObjectURL(url), 60_000);
      } else {
        bajar(url, `${nombre}.${formato}`);
        URL.revokeObjectURL(url);
      }
    } catch (causa) {
      notificar.error(causa instanceof ErrorDeApi ? causa.message : 'No se pudo armar el informe');
    } finally {
      setOcupado(null);
    }
  }

  return (
    <span className="inline-flex items-center gap-1.5">
      {rotulo && (
        <span className="mr-1 text-[10px] font-bold uppercase tracking-wide text-armazon-400">
          {rotulo}
        </span>
      )}

      {FORMATOS.map((formato) => (
        <button
          key={formato.valor}
          type="button"
          onClick={() => void sacar(formato.valor)}
          disabled={ocupado !== null}
          title={formato.ayuda}
          className={`inline-flex h-8 items-center gap-1.5 rounded-lg border px-3 text-[10px] font-bold uppercase tracking-wide transition disabled:opacity-40 ${
            formato.valor === 'pdf'
              ? 'border-armazon-800 bg-armazon-800 text-white hover:bg-armazon-900'
              : 'border-armazon-200 bg-white text-armazon-600 hover:border-armazon-300'
          }`}
        >
          {ocupado === formato.valor ? (
            <Loader2 className="size-3 animate-spin" aria-hidden />
          ) : (
            <Download className="size-3" aria-hidden />
          )}
          {formato.etiqueta}
        </button>
      ))}
    </span>
  );
}

function bajar(url: string, nombre: string) {
  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = nombre;
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
}
